import { rawTimeZones } from '@vvo/tzdb';

export const getCurrentUserTz = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone; // America/Chicago
export const isValidTz = (timeZone: string | undefined): boolean =>
  !timeZone || timeZone === 'UTC';

export const getUTCOffsetFromMins = (offsetMins: number) => {
  const hour = Math.abs(Math.floor(offsetMins / 60));
  const mins = Math.abs(offsetMins % 60);
  const sign = offsetMins < 0 ? '-' : '+';

  return `UTC${sign}${hour}:${mins !== 0 ? mins : '00'}`;
};

export const getTimezoneLabelWithOffset = (_timezone) => {
  const target = rawTimeZones.find(
    ({ name, group }) => name === _timezone || group.includes(_timezone),
  );

  if (!target) {
    return '';
  }

  return `(${getUTCOffsetFromMins(target.rawOffsetInMinutes)}) ${_timezone}`;
};

export const getTimezoneAbbreviation = (_timezone) =>
  rawTimeZones.find((data) => data.name === _timezone)?.abbreviation || '';

export const getCurrentTimeStampForTimezone = (_timezone) =>
  new Date().toLocaleString('en-US', { timeZone: _timezone });
